
import Component, { getInitialProps } from "../lists/[id]"

export default function ListOf(props) {
	return <Component {...props} />
}

ListOf.getInitialProps = getInitialProps
